// Fix for input placeholders prior to 9.1.7.
export function alterForms(culture) {
    var _a, _b;
    var textInputNodes = document.querySelectorAll('.node-text');
    if (!textInputNodes || textInputNodes.length === 0) {
        return;
    }
    for (var _i = 0, _c = Array.from(textInputNodes); _i < _c.length; _i++) {
        var node = _c[_i];
        var labelText = (_b = (_a = node.querySelector('.form-label-text')) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.replace('*', '');
        var targetInput = node.querySelector('label > input');
        if (labelText && labelText !== (targetInput === null || targetInput === void 0 ? void 0 : targetInput.getAttribute('placeholder'))) {
            targetInput === null || targetInput === void 0 ? void 0 : targetInput.setAttribute('placeholder', labelText);
        }
    }
}
